<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">供应商管理</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建供应商</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="searchData.Keyword"
        placeholder="请输入供应商名称"
        style="width: 300px; margin-left: 10px"
        clearable
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column label="供应商编号" align="center" prop="Code" sortable>
        </el-table-column>
        <el-table-column label="供应商名称" align="center" prop="Name" sortable>
        </el-table-column>
        <el-table-column
          label="供应商类型"
          align="center"
          prop="TypeNmae"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="供应商电话"
          align="center"
          prop="Phone"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="供应商联系人"
          align="center"
          prop="ContactName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="供应商Email"
          align="center"
          prop="Email"
          sortable
        >
        </el-table-column>
        <el-table-column label="状态" align="center" prop="States" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.States">启用</el-tag>
            <el-tag v-else type="danger">停用</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="货区类型" align="center" prop="Type">
          <template slot-scope="scope">
            <SelectDicName :typeValue="scope.row.Type" code="StorAreaType" />
          </template>
        </el-table-column> -->

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import SelectDicName from '@/components/DicValue/SelectDicName.vue'

import EditForm from './EditForm'
export default {
  data() {
    return {
      searchData: {
        Condition: 'Name',
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm, SelectDicName },
  methods: {
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/PB/PB_Supplier/QueryDataListPB_Supplier', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建供应商')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该供应商, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http.post('/PB/PB_Supplier/DeleteData', ids).then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('删除成功')
              this.getDataList()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑供应商', row)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
